export default [
    {
        path: '/student-enrollment',
        name: 'StudentEnrollment',
        component: () => import("@/views/Page/Enrollment/StudentEnrollment.vue"),
        meta: {
            title: '#Default# | Student Enrollment',
        },
    }
];

